export const GET_ALL_DC_LIST = {
    INIT: 'GET_ALL_DC_LIST_INIT',
    SUCCESS: 'GET_ALL_DC_LIST_SUCCESS',
    ERROR: 'GET_ALL_DC_LIST_ERROR'
}

export const SEARCHED_DC_LIST = {
    SET: 'SEARCHED_DC_LIST_SET'
}